import { IValidationsYupRoot } from "../models";

export const requiredRuleNumberField: IValidationsYupRoot = {
  type: "number",
  rules: [{ validation: "required" }],
};

export const requiredRuleStringField: IValidationsYupRoot = {
  type: "string",
  rules: [{ validation: "required" }],
};

export const OTP_LENGTH = 6;
